import { createFileRoute } from "@tanstack/react-router";
import { ParcelWeights } from "~/features/settings/parcel-settings";
import { SettingsIntro } from "~/features/settings/section";
import { useT } from "~/lib/i18n";

export const Route = createFileRoute("/_app/settings/shipping")({ component: ShippingSettingsPage });

function ShippingSettingsPage() {
  const t = useT();
  return (
    <>
      <SettingsIntro text={t("settings.pages.shipping.subtitle")} />
      <ParcelWeights />
    </>
  );
}
